export const PERMISSIONS_HEADER_CONFIG = [
  {
    group: 'sidebar.sections.cms',
    actions: [
      {
        title: 'sidebar.manage',
        icon: 'booking',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewBookingCms",
          'createCustomer.permissions.actions.headers.update', //"UpdateBookingCms"
        ],
      },
      {
        title: 'sidebar.media',
        icon: 'media',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewMediaCms",
          'createCustomer.permissions.actions.headers.update', //"UpdateMediaCms"
        ],
      },
      {
        title: 'sidebar.widgets',
        icon: 'widgets',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewWidgets",
          'createCustomer.permissions.actions.headers.update', //"UpdateWidgets"
        ],
      },
      {
        title: 'mediaTransfer.permission',
        icon: 'mediaTransfer',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewMediaTransfer",
          'createCustomer.permissions.actions.headers.update', //"UpdateMediaTransfer"
        ],
      },
    ],
  },
  {
    group: 'createCustomer.permissions.headers.analytics',
    actions: [
      {
        title: 'sidebar.reach',
        icon: 'reach',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewReachAnalytics"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.reachReports',
        icon: 'exposures-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewReachReportsAnalytics",
          'createCustomer.permissions.actions.headers.export', //"ExportReachReportsAnalytics"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.campaign',
        icon: 'exposure',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewExposuresAnalytics"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.campaignReports',
        icon: 'exposure-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewExposuresReportsAnalytics",
          'createCustomer.permissions.actions.headers.export', //"ExportExposuresReportsAnalytics"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.campaignSendouts',
        icon: 'exposure-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewCampaignSendouts",
          'createCustomer.permissions.actions.headers.update', //"UpdateCampaignSendouts"
          'createCustomer.permissions.actions.headers.export', //"ExportCampaignSendouts"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.forecast',
        icon: 'exposure-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewForecastAnalytics",
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.forecastEvent',
        icon: 'exposure-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewForecastEventAnalytics",
          'createCustomer.permissions.actions.headers.update', //"UpdateForecastEventAnalytics"
        ],
      },
    ],
  },
  {
    group: 'createCustomer.permissions.headers.visitorInsights',
    actions: [
      {
        title: 'createCustomer.permissions.actions.body.peopleCounter',
        icon: 'exposure-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewPeopleCounterInsights"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.peopleCounterReports',
        icon: 'people-counter-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewPeopleCounterReportsInsights",
          'createCustomer.permissions.actions.headers.export', //"ExportPeopleCounterReportsInsights"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.poi',
        icon: 'poi',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewPoiInsights",
          'createCustomer.permissions.actions.headers.update', //"UpdatePoiInsights"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.poiCategories',
        icon: 'poi-categories',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewPoiCategoriesInsights",
          'createCustomer.permissions.actions.headers.update', //"UpdatePoiCategoriesInsights"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.poiReports',
        icon: 'poi-reports',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewPoiReportsInsights",
          'createCustomer.permissions.actions.headers.export', //"ExportPoiReportsInsights"
        ],
      },
    ],
  },
  {
    group: 'createCustomer.permissions.headers.admin',
    actions: [
      {
        title: 'sidebar.sms',
        icon: 'sms',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewSmsAdmin"
        ],
      },
      {
        title: 'sidebar.channels',
        icon: 'channels',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewChannelAdmin",
          'createCustomer.permissions.actions.headers.update', //"UpdateChannelAdmin"
        ],
      },
      {
        title: 'sidebar.devices',
        icon: 'screens',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewScreensAdmin",
          'createCustomer.permissions.actions.headers.update', //"UpdateScreensAdmin"
        ],
      },
      {
        title: 'createCustomer.permissions.actions.body.devicesReports',
        icon: 'report-document',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewDevicesReportsAdmin",
          'createCustomer.permissions.actions.headers.export', //"ExportDevicesReportsAdmin"
        ],
      },
      {
        title: 'sidebar.clients',
        icon: 'clients',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewClientsAdmin",
          'createCustomer.permissions.actions.headers.update', //"UpdateClientsAdmin"
        ],
      },
      {
        title: 'sidebar.contactPersons',
        icon: 'contact-persons',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewContactPersonAdmin",
          'createCustomer.permissions.actions.headers.update', //"UpdateContactPersonAdmin"
        ],
      },
      {
        title: 'createCustomer.permissions.subTitles.permissions',
        icon: 'users-permissions',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewUserPermissionsAdmin",
          'createCustomer.permissions.actions.headers.update', //"UpdateUserPermissionsAdmin"
        ],
      },
      {
        title: 'sidebar.users',
        icon: 'users',
        permissions: [
          'createCustomer.permissions.actions.headers.view', //"ViewUsersAdmin",
          'createCustomer.permissions.actions.headers.update', //"UpdateUsersAdmin"
        ],
      },
    ],
  },
];